var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-div"},[_vm._v(" "+_vm._s(_vm.config.text || '')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }